import { Text } from "@/components/ui/text";
import { Center } from "@/components/ui/center";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useIsMounted from '../../hooks/mounted';
import { switchScreen } from '../../hooks/navigate';
import BasicButton from '../../components/basic/BasicButton';
import { storeTemp } from "../../stores/mainSlice";

export default function ScreenB({ navigation, route }) {
    console.log(route)
    const name = 'ScreenB'
    const next = 'ScreenA'
    const { routeData } = route.params ? route.params : { routeData: {} }
    const reduxData = useSelector((state) => state.temp.reduxData || {})
    const user = useSelector((state) => state.user)

    const dispatch = useDispatch()
    const mounted = useIsMounted()

    useEffect(() => {
        console.log('MOUNT', name, routeData, reduxData, user.preferredName)
        return () => {
            if (!mounted()) {
                reduxData.list[0] += 10
                reduxData.info.msg += 'Z'
                console.log('UNMOUNT', name, routeData, reduxData, user.preferredName)
                dispatch(storeTemp({ temp: { reduxData: { ...reduxData } } }))
            }
        };
    }, [mounted])


    useEffect(() => {
        return navigation.addListener('beforeRemove', (e) => {
            // e.preventDefault()
        })
    }, [navigation])

    const onPress = () => {
        routeData.list[0] += 3
        switchScreen(navigation, next, { routeData: routeData })
    }

    const onBack = () => {
        routeData.list[1] += 3
        switchScreen(navigation, 'BACK')
    }

    console.log('RENDER', name)
    return (
        <Center className="flex-1 m-0 bg-orange.200">
            <Text className="text-2xl font-[800] text-secondary-900 mt-6">{'Data Transfer B => A'}</Text>
            <Text bold className="text-2xl text-secondary-900 mt-6">{name}</Text>
            <Text className="text-sx text-secondary-900 mt-6">{'Via navigation: ' + JSON.stringify(routeData, null, 2)}</Text>
            <Text className="text-sx text-secondary-900 mt-6">{'Via Redux: ' + JSON.stringify(reduxData, null, 2)}</Text>
            <BasicButton width='50%' bg='bg-primary-900' onPress={onPress} text={next} />
            <BasicButton width='50%' bg='bg-primary-900' onPress={onBack} text='BACK' />
        </Center>
    );
}
/*
  cvt["next = "]=0
  cvt["name = "]=0
*/
